import HeroAnchor from '../components/HeroAnchor';

import emailUtils from '../utils/emailUtils';

const streetEasyUrl = 'https://streeteasy.com/nyc/submit_your_listings';
const learnMoreUrl =
  'http://www.zillow.com/rental-property-advertising?utm_medium=referral&utm_content=learnmorelink' +
  '&utm_source=zrm&utm_campaign=zrm_add_property';

const ErrorMessageConstants = {
  LOCATION_RESTRICTION: {
    NYC: (
      <span>
        This listing can&apos;t be published. Please visit{' '}
        <HeroAnchor key="LOCATION_RESTRICTION_NYC" href={streetEasyUrl} target="_blank" rel="noopener noreferrer">
          StreetEasy
        </HeroAnchor>{' '}
        to list a rental in this area of New York.
      </span>
    ),
    MF_REQUIRED: (
      <span>
        This address is a 25+ unit apartment community, which requires a Zillow advertising contract. For more
        information, see{' '}
        <HeroAnchor
          key="LOCATION_RESTRICTION_MF_REQUIRED"
          href={learnMoreUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </HeroAnchor>
        .
      </span>
    ),
    DUPLICATE: {
      MESSAGE: 'This property is already posted.',
      LINK_TEXT: 'View Listing',
    },
  },
  DEFAULT_LISTING_ERROR: 'There was an error loading your property. Please try again.',
  DEFAULT_PHOTO_ERROR: 'There was an error with your photo upload. Please check the field for errors and try again.',
  DELETE_LAST_PHOTO_ACTIVE_LISTING_ERROR: 'Active listings must have at least one photo',
  DELETE_PHOTO_ERROR: 'There was an error deleting the photo. Please, try again.',
  DEFAULT_ERROR: 'Sorry, something went wrong. Please try again later.',
  SINGLE_FAMILY_NO_ACTIVE_CONTRACT: (
    <span>
      There is no active contract. Please contact{' '}
      <HeroAnchor target="_blank" href="mailto:rentalfeedinquiries@zillowgroup.com">
        rentalfeedinquiries@zillowgroup.com
      </HeroAnchor>
      .
    </span>
  ),
  SINGLE_FAMILY_CANNOT_RETRIEVE_CONTRACTS: 'Cannot retrieve active contacts, please try again later.',
  PAID_LISTING_DUPE_ERROR: (isMFSupport = false, isSingleFamilyEnterpriseCustomer = false) => (
    <span>
      Another partner has an active listing at this location. If you are the owner/manager of this location, please{' '}
      <HeroAnchor
        key="LOCATION_RESTRICTION_PAID_LISTING_DUPE_ERROR"
        href={`mailto:${emailUtils.getHelpEmail(isMFSupport, isSingleFamilyEnterpriseCustomer)}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        contact support
      </HeroAnchor>
      .
    </span>
  ),
  EXTERNAL_TOUR_INVALID_URL: 'The tour link is invalid.',
  EXTERNAL_TOUR_ALREADY_EXIST: 'This tour link already exists.',
  EXTERNAL_TOUR_NOT_SUPPORTED_PROVIDER: 'This source is not supported.',
  EXTERNAL_TOUR_NO_PERMISSION: (isMFSupport = false, isSingleFamilyEnterpriseCustomer = false) => (
    <span>
      You don&apos;t have access to add external tours. Please reach out to support for help:{' '}
      <HeroAnchor
        target="_blank"
        href={`mailto:${emailUtils.getHelpEmail(isMFSupport, isSingleFamilyEnterpriseCustomer)}`}
      >
        {emailUtils.getHelpEmail(isMFSupport)}
      </HeroAnchor>
    </span>
  ),
  LISTING_NO_PERMISSION: `This listing belongs to a different user and you do not have permission to access it.
            If you believe you should be able to access this listing,
            please make sure you are signed in to the same account that created this listing.`,
  TECHNICAL_DIFFICULTIES: 'Zillow Rental Manager is experiencing technical difficulties. Please, try again later.',
};

export default ErrorMessageConstants;
